import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type Article = {
  __typename: 'Article';
  content: Scalars['String'];
  contentId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  /**
   * deprecated
   * @deprecated It will be removed
   */
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  image1: Scalars['String'];
  image2: Scalars['String'];
  image3: Scalars['String'];
  image4: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ArticleEdge = {
  __typename: 'ArticleEdge';
  cursor: Scalars['ID'];
  node: Article;
};

export type ArticlesConnection = {
  __typename: 'ArticlesConnection';
  /**
   * deprecated
   * @deprecated Use `nodes`.
   */
  articles: Array<Article>;
  edges?: Maybe<Array<ArticleEdge>>;
  nodes: Array<Article>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Attachment = {
  __typename: 'Attachment';
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['ID'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  kind: Kind;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type BookmarkedCafe = {
  __typename: 'BookmarkedCafe';
  cafe: Cafe;
  cafeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['ID'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userUid: Scalars['String'];
};

export type BookmarkedCafeConnection = {
  __typename: 'BookmarkedCafeConnection';
  edges: Array<BookmarkedCafeEdge>;
  pageInfo: NewPageInfo;
  totalCount: Scalars['Int'];
};

export type BookmarkedCafeEdge = {
  __typename: 'BookmarkedCafeEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: BookmarkedCafe;
};

export type Brand = {
  __typename: 'Brand';
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BrandConnection = {
  __typename: 'BrandConnection';
  edges: Array<BrandEdge>;
  pageInfo: NewPageInfo;
  totalCount: Scalars['Int'];
};

export type BrandEdge = {
  __typename: 'BrandEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: Brand;
};

export type BrandOrderByInput = {
  createdAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type BrandWhereInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type Cafe = {
  __typename: 'Cafe';
  access?: Maybe<Scalars['String']>;
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  bookmarkedCafe?: Maybe<BookmarkedCafe>;
  branchName?: Maybe<Scalars['String']>;
  brand: Brand;
  businessHours?: Maybe<Scalars['String']>;
  cafeToCafeTags: Array<CafeToCafeTag>;
  cafeToSponsors: Array<CafeToSponsor>;
  cafeToUsages: Array<CafeToUsage>;
  chargingMemo?: Maybe<Scalars['String']>;
  chargingPermission: ChargingPermission;
  city: Scalars['String'];
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['ID'];
  description: Scalars['String'];
  displayId?: Maybe<Scalars['Int']>;
  holiday?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image1?: Maybe<Scalars['String']>;
  image2?: Maybe<Scalars['String']>;
  image3?: Maybe<Scalars['String']>;
  image4?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  meal?: Maybe<Meal>;
  memo?: Maybe<Scalars['String']>;
  mobileBatteryMemo?: Maybe<Scalars['String']>;
  mobileBatteryPermission: MobileBatteryPermission;
  name?: Maybe<Scalars['String']>;
  official?: Maybe<Scalars['Boolean']>;
  outletsCount: Scalars['Int'];
  path?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pictures: Array<Attachment>;
  postalcode: Scalars['String'];
  prefecture: Scalars['String'];
  recommendation?: Maybe<Scalars['String']>;
  reviewComment?: Maybe<Scalars['String']>;
  smoking: Smoking;
  takeAwayAvailable?: Maybe<Scalars['Boolean']>;
  terraceSeatsAvailable: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  wifi: WiFi;
  wifiMemo?: Maybe<Scalars['String']>;
};

export type CafeBrandWhereInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CafeByCafeTagWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  cafeTagId?: InputMaybe<Scalars['ID']>;
  cafeTagSlug?: InputMaybe<Scalars['String']>;
};

export type CafeConnection = {
  __typename: 'CafeConnection';
  edges: Array<CafeEdge>;
  pageInfo: NewPageInfo;
  totalCount: Scalars['Int'];
};

export type CafeEdge = {
  __typename: 'CafeEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: Cafe;
};

export type CafeMealWhereInput = {
  alcohol?: InputMaybe<Scalars['Boolean']>;
  dessert?: InputMaybe<Scalars['Boolean']>;
  dinner?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  lunch?: InputMaybe<Scalars['Boolean']>;
  morning?: InputMaybe<Scalars['Boolean']>;
  snack?: InputMaybe<Scalars['Boolean']>;
};

export type CafeOrderByInput = {
  createdAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type CafeRegionInput = {
  latitude: Scalars['Float'];
  latitudeDelta?: InputMaybe<Scalars['Float']>;
  longitude: Scalars['Float'];
  longitudeDelta?: InputMaybe<Scalars['Float']>;
};

export type CafeSearch = {
  __typename: 'CafeSearch';
  access: Scalars['String'];
  address: Scalars['String'];
  au: Scalars['String'];
  businessHours: Scalars['String'];
  contentId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  demerit: Scalars['String'];
  distance?: Maybe<Scalars['Float']>;
  docomo: Scalars['String'];
  heatedTabacco: Scalars['String'];
  holidays: Scalars['String'];
  id: Scalars['ID'];
  image1: Scalars['String'];
  image2: Scalars['String'];
  image3: Scalars['String'];
  image4: Scalars['String'];
  internalCleanliness: Scalars['String'];
  is24h: Scalars['Boolean'];
  isBookmarked?: Maybe<Scalars['Boolean']>;
  isCreditCard: Scalars['Boolean'];
  isECigarette: Scalars['Boolean'];
  isEMoney: Scalars['Boolean'];
  isLateNight: Scalars['Boolean'];
  isNoSmoking: Scalars['Boolean'];
  isParking: Scalars['Boolean'];
  isSmoking: Scalars['Boolean'];
  isWirelessLan: Scalars['Boolean'];
  lastModified: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  meal: Scalars['String'];
  mobileBattery: Scalars['String'];
  name: Scalars['String'];
  networks: Scalars['String'];
  nomachiReceivedAt?: Maybe<Scalars['DateTime']>;
  nomachiStatus?: Maybe<CafeSearchNomachiStatus>;
  nomadimage: Scalars['String'];
  notes: Scalars['String'];
  outletPermission: Scalars['String'];
  outlets: Scalars['String'];
  powerNum: Scalars['String'];
  recommendation: Scalars['String'];
  restroomCleanliness: Scalars['String'];
  review: Scalars['String'];
  situation: Scalars['String'];
  smokingSeat: Scalars['String'];
  softbank: Scalars['String'];
  sunlight: Scalars['String'];
  tel: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  wifibrand: Scalars['String'];
  wimax: Scalars['String'];
  wirelessLan: Scalars['String'];
};

export type CafeSearchCandidateResult = {
  __typename: 'CafeSearchCandidateResult';
  /**
   * deprecated
   * @deprecated Use `cafesConnection`.
   */
  cafes: CafeSearchesConnection;
  cafesConnection: CafeSearchesConnection;
  geos: Array<Geo>;
};

export enum CafeSearchCondition {
  Creditcard = 'CREDITCARD',
  ECigarette = 'E_CIGARETTE',
  EMoney = 'E_MONEY',
  H24 = 'H24',
  LateNight = 'LATE_NIGHT',
  NoSmoking = 'NO_SMOKING',
  Parking = 'PARKING',
  Smoking = 'SMOKING',
  WirelessLan = 'WIRELESS_LAN'
}

export type CafeSearchEdge = {
  __typename: 'CafeSearchEdge';
  cursor: Scalars['ID'];
  node: CafeSearch;
};

export enum CafeSearchNomachiStatus {
  Available = 'AVAILABLE',
  Close = 'CLOSE',
  Crowded = 'CROWDED',
  FewLeft = 'FEW_LEFT',
  InPreparation = 'IN_PREPARATION',
  Unknown = 'UNKNOWN'
}

export type CafeSearchResult = {
  __typename: 'CafeSearchResult';
  /**
   * deprecated
   * @deprecated Use `cafesConnection`.
   */
  cafes: CafeSearchesConnection;
  cafesConnection: CafeSearchesConnection;
  region?: Maybe<Region>;
};

export type CafeSearchesConnection = {
  __typename: 'CafeSearchesConnection';
  /**
   * deprecated
   * @deprecated Use `nodes`.
   */
  cafes: Array<CafeSearch>;
  edges?: Maybe<Array<CafeSearchEdge>>;
  nodes: Array<CafeSearch>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CafeTag = {
  __typename: 'CafeTag';
  archived: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CafeTagConnection = {
  __typename: 'CafeTagConnection';
  edges: Array<CafeTagEdge>;
  pageInfo: NewPageInfo;
  totalCount: Scalars['Int'];
};

export type CafeTagEdge = {
  __typename: 'CafeTagEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: CafeTag;
};

export type CafeTagOrderByInput = {
  createdAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type CafeTagWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
};

export type CafeToCafeTag = {
  __typename: 'CafeToCafeTag';
  cafeTag?: Maybe<CafeTag>;
  databaseId: Scalars['ID'];
  id: Scalars['ID'];
};

export type CafeToSponsor = {
  __typename: 'CafeToSponsor';
  databaseId: Scalars['ID'];
  id: Scalars['ID'];
  sponsor?: Maybe<Sponsor>;
};

export type CafeToUsage = {
  __typename: 'CafeToUsage';
  databaseId: Scalars['ID'];
  id: Scalars['ID'];
  usage?: Maybe<Usage>;
};

export type CafeWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  brand?: InputMaybe<CafeBrandWhereInput>;
  cafeTagIds?: InputMaybe<Array<Scalars['ID']>>;
  chargingPermission?: InputMaybe<ChargingPermission>;
  city?: InputMaybe<Scalars['String']>;
  isCafe?: InputMaybe<Scalars['Boolean']>;
  meal?: InputMaybe<CafeMealWhereInput>;
  mobileBatteryPermission?: InputMaybe<MobileBatteryPermission>;
  official?: InputMaybe<Scalars['Boolean']>;
  outletsCount?: InputMaybe<Scalars['Int']>;
  prefecture?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  smoking?: InputMaybe<Array<Smoking>>;
  sponsorIds?: InputMaybe<Array<Scalars['ID']>>;
  takeAwayAvailable?: InputMaybe<Scalars['Boolean']>;
  terraceSeatsAvailable?: InputMaybe<Scalars['Boolean']>;
  usageIds?: InputMaybe<Array<Scalars['ID']>>;
  wifi?: InputMaybe<WiFi>;
};

export enum ChargingPermission {
  Necessary = 'NECESSARY',
  Unknown = 'UNKNOWN',
  Unnecessary = 'UNNECESSARY'
}

export type ConnectionInput = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type Geo = {
  __typename: 'Geo';
  address: Scalars['String'];
  contentId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  type: GeoType;
  updatedAt: Scalars['DateTime'];
};

export type GeoEdge = {
  __typename: 'GeoEdge';
  cursor: Scalars['ID'];
  node: Geo;
};

export type GeoRegionInput = {
  latitude: Scalars['Float'];
  latitudeDelta?: InputMaybe<Scalars['Float']>;
  longitude: Scalars['Float'];
  longitudeDelta?: InputMaybe<Scalars['Float']>;
};

export enum GeoType {
  Station = 'STATION'
}

export type GeosConnection = {
  __typename: 'GeosConnection';
  edges?: Maybe<Array<GeoEdge>>;
  /**
   * deprecated
   * @deprecated Use `nodes`.
   */
  geos: Array<Geo>;
  nodes: Array<Geo>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum Kind {
  Cafe = 'CAFE'
}

export type Meal = {
  __typename: 'Meal';
  alcohol: Scalars['Boolean'];
  databaseId: Scalars['ID'];
  dessert: Scalars['Boolean'];
  dinner: Scalars['Boolean'];
  id: Scalars['ID'];
  lunch: Scalars['Boolean'];
  morning: Scalars['Boolean'];
  snack: Scalars['Boolean'];
};

export enum MobileBatteryPermission {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE',
  Unknown = 'UNKNOWN'
}

export type Mutation = {
  __typename: 'Mutation';
  createBookmarkedCafe: Scalars['Boolean'];
  createUser?: Maybe<User>;
  deleteBookmarkedCafe: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  /**
   * deprecated
   * @deprecated Use `bookmarkedCafe mutation` instead
   */
  toggleBookmark?: Maybe<CafeSearch>;
};


export type MutationCreateBookmarkedCafeArgs = {
  cafeId: Scalars['ID'];
};


export type MutationCreateUserArgs = {
  token: Scalars['String'];
};


export type MutationDeleteBookmarkedCafeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  token: Scalars['String'];
};


export type MutationToggleBookmarkArgs = {
  cafeId: Scalars['Int'];
};

export type NewPageInfo = {
  __typename: 'NewPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
};

export type Node = {
  __typename: 'Node';
  id: Scalars['ID'];
};

export enum Order {
  Created = 'CREATED',
  Updated = 'UPDATED'
}

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderByInput = {
  createdAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename: 'Query';
  article: Article;
  /**
   * deprecated
   * @deprecated Use `articlesConnection` instead
   */
  articles: ArticlesConnection;
  articlesConnection: ArticlesConnection;
  bookmarkedCafes: BookmarkedCafeConnection;
  /**
   * deprecated
   * @deprecated Use `bookmarkedCafes` instead
   */
  bookmarks: CafeSearchesConnection;
  brand: Brand;
  brands: BrandConnection;
  /**
   * deprecated
   * @deprecated Use `newCafe` instead
   */
  cafe?: Maybe<CafeSearch>;
  cafeByPath: Cafe;
  /**
   * deprecated
   * @deprecated Use `newCafe` instead
   */
  cafeSearch: CafeSearchResult;
  /**
   * deprecated
   * @deprecated Use `newCafes` instead
   */
  cafeSearchCandidates: CafeSearchCandidateResult;
  cafeTag: CafeTag;
  cafeTagBySlug: CafeTag;
  cafeTags: CafeTagConnection;
  /**
   * deprecated
   * @deprecated Use `cafesConnection` instead
   */
  cafes: CafeSearchesConnection;
  cafesByCafeTag: CafeConnection;
  /**
   * deprecated
   * @deprecated Use `newCafes` instead
   */
  cafesConnection: CafeSearchesConnection;
  /**
   * deprecated
   * @deprecated Use `station` instead
   */
  geo: Geo;
  /**
   * deprecated
   * @deprecated Use `stations` instead
   */
  geoSearch: Array<Geo>;
  /**
   * deprecated
   * @deprecated Use `stations` instead
   */
  geos: GeosConnection;
  meal: Meal;
  newCafe: Cafe;
  newCafes: CafeConnection;
  sponsor: Sponsor;
  sponsors: SponsorConnection;
  station: Station;
  stations: StationConnection;
  /**
   * deprecated
   * @deprecated Use `newCafes` instead
   */
  term: TermResult;
  usage: Usage;
  usages: UsageConnection;
};


export type QueryArticleArgs = {
  contentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Order>;
};


export type QueryArticlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<OrderByInput>;
};


export type QueryBookmarkedCafesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryBookmarksArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<OrderByInput>;
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
};


export type QueryBrandsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BrandOrderByInput>;
  where?: InputMaybe<BrandWhereInput>;
};


export type QueryCafeArgs = {
  contentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCafeByPathArgs = {
  path: Scalars['String'];
};


export type QueryCafeSearchArgs = {
  after?: InputMaybe<Scalars['ID']>;
  condition?: InputMaybe<Array<CafeSearchCondition>>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<RegionInput>;
};


export type QueryCafeSearchCandidatesArgs = {
  cafe?: InputMaybe<ConnectionInput>;
  condition?: InputMaybe<Array<CafeSearchCondition>>;
  geo?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<RegionInput>;
};


export type QueryCafeTagArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryCafeTagBySlugArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type QueryCafeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CafeTagOrderByInput>;
  where?: InputMaybe<CafeTagWhereInput>;
};


export type QueryCafesArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Order>;
};


export type QueryCafesByCafeTagArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CafeOrderByInput>;
  where?: InputMaybe<CafeByCafeTagWhereInput>;
};


export type QueryCafesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<OrderByInput>;
};


export type QueryGeoArgs = {
  contentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGeoSearchArgs = {
  first?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryGeosArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<GeoRegionInput>;
};


export type QueryMealArgs = {
  id: Scalars['ID'];
};


export type QueryNewCafeArgs = {
  id: Scalars['ID'];
};


export type QueryNewCafesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CafeOrderByInput>;
  region?: InputMaybe<CafeRegionInput>;
  where?: InputMaybe<CafeWhereInput>;
};


export type QuerySponsorArgs = {
  id: Scalars['ID'];
};


export type QuerySponsorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SponsorOrderByInput>;
  where?: InputMaybe<SponsorWhereInput>;
};


export type QueryStationArgs = {
  id: Scalars['ID'];
};


export type QueryStationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<StationOrderByInput>;
  region?: InputMaybe<StationRegionInput>;
  where?: InputMaybe<StationWhereInput>;
};


export type QueryTermArgs = {
  article: ConnectionInput;
  cafe: ConnectionInput;
  slug: Scalars['String'];
};


export type QueryUsageArgs = {
  id: Scalars['ID'];
};


export type QueryUsagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsageOrderByInput>;
};

export type Region = {
  __typename: 'Region';
  latitude: Scalars['Float'];
  latitudeDelta: Scalars['Float'];
  longitude: Scalars['Float'];
  longitudeDelta: Scalars['Float'];
};

export type RegionInput = {
  latitude: Scalars['Float'];
  latitudeDelta?: InputMaybe<Scalars['Float']>;
  longitude: Scalars['Float'];
  longitudeDelta?: InputMaybe<Scalars['Float']>;
};

export enum Smoking {
  CigaretteAtSeat = 'CIGARETTE_AT_SEAT',
  CigaretteAtSpace = 'CIGARETTE_AT_SPACE',
  EcigaretteAtSeat = 'ECIGARETTE_AT_SEAT',
  EcigaretteAtSpace = 'ECIGARETTE_AT_SPACE',
  NonSmoking = 'NON_SMOKING',
  Unknown = 'UNKNOWN'
}

export type Sponsor = {
  __typename: 'Sponsor';
  archived: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SponsorConnection = {
  __typename: 'SponsorConnection';
  edges: Array<SponsorEdge>;
  pageInfo: NewPageInfo;
  totalCount: Scalars['Int'];
};

export type SponsorEdge = {
  __typename: 'SponsorEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: Sponsor;
};

export type SponsorOrderByInput = {
  createdAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type SponsorWhereInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type Station = {
  __typename: 'Station';
  address?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['ID'];
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  query: Scalars['String'];
  route?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type StationConnection = {
  __typename: 'StationConnection';
  edges: Array<StationEdge>;
  pageInfo: NewPageInfo;
  totalCount: Scalars['Int'];
};

export type StationEdge = {
  __typename: 'StationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: Station;
};

export type StationOrderByInput = {
  createdAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type StationRegionInput = {
  latitude: Scalars['Float'];
  latitudeDelta?: InputMaybe<Scalars['Float']>;
  longitude: Scalars['Float'];
  longitudeDelta?: InputMaybe<Scalars['Float']>;
};

export type StationWhereInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type TermResult = {
  __typename: 'TermResult';
  articlesConnection: ArticlesConnection;
  cafesConnection: CafeSearchesConnection;
  id: Scalars['ID'];
  name: Scalars['String'];
  region?: Maybe<Region>;
  slug: Scalars['String'];
  /**
   * deprecated
   * @deprecated Simplified when moved to v3
   */
  taxonomy: Scalars['String'];
};

export type Usage = {
  __typename: 'Usage';
  archived: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  databaseId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UsageConnection = {
  __typename: 'UsageConnection';
  edges: Array<UsageEdge>;
  pageInfo: NewPageInfo;
  totalCount: Scalars['Int'];
};

export type UsageEdge = {
  __typename: 'UsageEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: Usage;
};

export type UsageOrderByInput = {
  createdAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type User = {
  __typename: 'User';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  uid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum WiFi {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE',
  Unknown = 'UNKNOWN'
}

export type ArticleQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type ArticleQuery = { __typename: 'Query', article: { __typename: 'Article', id: string, contentId: number, title: string, content: string, description: string, image1: string, image2: string, image3: string, image4: string, createdAt: any, updatedAt: any } };

export type ArticlePage_ArticleFragment = { __typename: 'Article', id: string, contentId: number, title: string, content: string, description: string, image1: string, image2: string, image3: string, image4: string, createdAt: any, updatedAt: any };

export type ArticlesIndexQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Order>;
}>;


export type ArticlesIndexQuery = { __typename: 'Query', articles: { __typename: 'ArticlesConnection', totalCount: number, edges?: Array<{ __typename: 'ArticleEdge', node: { __typename: 'Article', id: string, contentId: number, title: string, content: string, description: string, image1: string, image2: string, image3: string, image4: string, createdAt: any, updatedAt: any } }> | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null } } };

export type CafeQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type CafeQuery = { __typename: 'Query', cafe: { __typename: 'Cafe', id: string, databaseId: string, path?: string | null, access?: string | null, address1: string, address2?: string | null, branchName?: string | null, businessHours?: string | null, chargingMemo?: string | null, chargingPermission: ChargingPermission, city: string, createdAt: any, description: string, holiday?: string | null, latitude?: number | null, longitude?: number | null, memo?: string | null, mobileBatteryMemo?: string | null, mobileBatteryPermission: MobileBatteryPermission, name?: string | null, official?: boolean | null, outletsCount: number, phone?: string | null, postalcode: string, prefecture: string, recommendation?: string | null, reviewComment?: string | null, smoking: Smoking, takeAwayAvailable?: boolean | null, terraceSeatsAvailable: boolean, updatedAt: any, url?: string | null, wifi: WiFi, wifiMemo?: string | null, brand: { __typename: 'Brand', id: string, name: string }, cafeToCafeTags: Array<{ __typename: 'CafeToCafeTag', cafeTag?: { __typename: 'CafeTag', id: string, name: string, slug: string } | null }>, cafeToSponsors: Array<{ __typename: 'CafeToSponsor', sponsor?: { __typename: 'Sponsor', id: string, name: string } | null }>, cafeToUsages: Array<{ __typename: 'CafeToUsage', usage?: { __typename: 'Usage', id: string, name: string } | null }>, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }>, meal?: { __typename: 'Meal', id: string, alcohol: boolean, dessert: boolean, dinner: boolean, lunch: boolean, morning: boolean, snack: boolean } | null } };

export type CafePage_CafeFragment = { __typename: 'Cafe', id: string, databaseId: string, path?: string | null, access?: string | null, address1: string, address2?: string | null, branchName?: string | null, businessHours?: string | null, chargingMemo?: string | null, chargingPermission: ChargingPermission, city: string, createdAt: any, description: string, holiday?: string | null, latitude?: number | null, longitude?: number | null, memo?: string | null, mobileBatteryMemo?: string | null, mobileBatteryPermission: MobileBatteryPermission, name?: string | null, official?: boolean | null, outletsCount: number, phone?: string | null, postalcode: string, prefecture: string, recommendation?: string | null, reviewComment?: string | null, smoking: Smoking, takeAwayAvailable?: boolean | null, terraceSeatsAvailable: boolean, updatedAt: any, url?: string | null, wifi: WiFi, wifiMemo?: string | null, brand: { __typename: 'Brand', id: string, name: string }, cafeToCafeTags: Array<{ __typename: 'CafeToCafeTag', cafeTag?: { __typename: 'CafeTag', id: string, name: string, slug: string } | null }>, cafeToSponsors: Array<{ __typename: 'CafeToSponsor', sponsor?: { __typename: 'Sponsor', id: string, name: string } | null }>, cafeToUsages: Array<{ __typename: 'CafeToUsage', usage?: { __typename: 'Usage', id: string, name: string } | null }>, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }>, meal?: { __typename: 'Meal', id: string, alcohol: boolean, dessert: boolean, dinner: boolean, lunch: boolean, morning: boolean, snack: boolean } | null };

export type CafePage_UsageFragment = { __typename: 'Usage', id: string, name: string };

export type CafePage_CafeTagFragment = { __typename: 'CafeTag', id: string, name: string, slug: string };

export type CafePage_SponsorFragment = { __typename: 'Sponsor', id: string, name: string };

export type CafePage_MealFragment = { __typename: 'Meal', id: string, alcohol: boolean, dessert: boolean, dinner: boolean, lunch: boolean, morning: boolean, snack: boolean };

export type CafePage_AttachmentFragment = { __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any };

export type CafesIndexQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
}>;


export type CafesIndexQuery = { __typename: 'Query', newCafes: { __typename: 'CafeConnection', totalCount: number, pageInfo: { __typename: 'NewPageInfo', hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'CafeEdge', node: { __typename: 'Cafe', id: string, databaseId: string, path?: string | null, access?: string | null, address1: string, address2?: string | null, branchName?: string | null, businessHours?: string | null, chargingMemo?: string | null, chargingPermission: ChargingPermission, city: string, createdAt: any, description: string, holiday?: string | null, latitude?: number | null, longitude?: number | null, memo?: string | null, mobileBatteryMemo?: string | null, mobileBatteryPermission: MobileBatteryPermission, name?: string | null, official?: boolean | null, outletsCount: number, phone?: string | null, postalcode: string, prefecture: string, recommendation?: string | null, reviewComment?: string | null, smoking: Smoking, takeAwayAvailable?: boolean | null, terraceSeatsAvailable: boolean, updatedAt: any, url?: string | null, wifi: WiFi, wifiMemo?: string | null, brand: { __typename: 'Brand', id: string, name: string }, cafeToCafeTags: Array<{ __typename: 'CafeToCafeTag', cafeTag?: { __typename: 'CafeTag', id: string, name: string, slug: string } | null }>, cafeToSponsors: Array<{ __typename: 'CafeToSponsor', sponsor?: { __typename: 'Sponsor', id: string, name: string } | null }>, cafeToUsages: Array<{ __typename: 'CafeToUsage', usage?: { __typename: 'Usage', id: string, name: string } | null }>, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }>, meal?: { __typename: 'Meal', id: string, alcohol: boolean, dessert: boolean, dinner: boolean, lunch: boolean, morning: boolean, snack: boolean } | null } }> } };

export type HeaderSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type HeaderSearchQuery = { __typename: 'Query', stations: { __typename: 'StationConnection', totalCount: number, pageInfo: { __typename: 'NewPageInfo', hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'StationEdge', node: { __typename: 'Station', id: string, databaseId: string, name: string, route?: string | null, address?: string | null, query: string, latitude: number, longitude: number } }> } };

export type HomeArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeArticlesQuery = { __typename: 'Query', articles: { __typename: 'ArticlesConnection', edges?: Array<{ __typename: 'ArticleEdge', node: { __typename: 'Article', id: string, contentId: number, title: string, content: string, description: string, image1: string, image2: string, image3: string, image4: string, createdAt: any, updatedAt: any } }> | null } };

export type HomeCafe_CafeFragment = { __typename: 'Cafe', id: string, path?: string | null, branchName?: string | null, name?: string | null, description: string, official?: boolean | null, access?: string | null, brand: { __typename: 'Brand', id: string, name: string }, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }> };

export type HomeCafe_AttachmentFragment = { __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any };

export type HomeCafesQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeCafesQuery = { __typename: 'Query', newCafes: { __typename: 'CafeConnection', totalCount: number, pageInfo: { __typename: 'NewPageInfo', hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'CafeEdge', node: { __typename: 'Cafe', id: string, path?: string | null, branchName?: string | null, name?: string | null, description: string, official?: boolean | null, access?: string | null, brand: { __typename: 'Brand', id: string, name: string }, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }> } }> } };

export type HomeSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<StationRegionInput>;
}>;


export type HomeSearchQuery = { __typename: 'Query', stations: { __typename: 'StationConnection', totalCount: number, pageInfo: { __typename: 'NewPageInfo', hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'StationEdge', node: { __typename: 'Station', id: string, databaseId: string, name: string, route?: string | null, address?: string | null, query: string, latitude: number, longitude: number } }> } };

export type LatestArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestArticlesQuery = { __typename: 'Query', articles: { __typename: 'ArticlesConnection', totalCount: number, edges?: Array<{ __typename: 'ArticleEdge', node: { __typename: 'Article', id: string, contentId: number, title: string, content: string, description: string, image1: string, image2: string, image3: string, image4: string, createdAt: any, updatedAt: any } }> | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null } } };

export type RelatedCafesQueryVariables = Exact<{
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}>;


export type RelatedCafesQuery = { __typename: 'Query', newCafes: { __typename: 'CafeConnection', totalCount: number, pageInfo: { __typename: 'NewPageInfo', hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'CafeEdge', node: { __typename: 'Cafe', id: string, databaseId: string, path?: string | null, access?: string | null, address1: string, address2?: string | null, branchName?: string | null, businessHours?: string | null, chargingMemo?: string | null, chargingPermission: ChargingPermission, city: string, createdAt: any, description: string, holiday?: string | null, latitude?: number | null, longitude?: number | null, memo?: string | null, mobileBatteryMemo?: string | null, mobileBatteryPermission: MobileBatteryPermission, name?: string | null, official?: boolean | null, outletsCount: number, phone?: string | null, postalcode: string, prefecture: string, recommendation?: string | null, reviewComment?: string | null, smoking: Smoking, takeAwayAvailable?: boolean | null, terraceSeatsAvailable: boolean, updatedAt: any, url?: string | null, wifi: WiFi, wifiMemo?: string | null, brand: { __typename: 'Brand', id: string, name: string }, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }> } }> } };

export type RelatedCafe_CafeFragment = { __typename: 'Cafe', id: string, databaseId: string, path?: string | null, access?: string | null, address1: string, address2?: string | null, branchName?: string | null, businessHours?: string | null, chargingMemo?: string | null, chargingPermission: ChargingPermission, city: string, createdAt: any, description: string, holiday?: string | null, latitude?: number | null, longitude?: number | null, memo?: string | null, mobileBatteryMemo?: string | null, mobileBatteryPermission: MobileBatteryPermission, name?: string | null, official?: boolean | null, outletsCount: number, phone?: string | null, postalcode: string, prefecture: string, recommendation?: string | null, reviewComment?: string | null, smoking: Smoking, takeAwayAvailable?: boolean | null, terraceSeatsAvailable: boolean, updatedAt: any, url?: string | null, wifi: WiFi, wifiMemo?: string | null, brand: { __typename: 'Brand', id: string, name: string }, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }> };

export type SearchCafeUsagePickerQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchCafeUsagePickerQuery = { __typename: 'Query', usages: { __typename: 'UsageConnection', edges: Array<{ __typename: 'UsageEdge', node: { __typename: 'Usage', id: string, name: string } }> } };

export type SearchCafeUsagePicker_UsageFragment = { __typename: 'Usage', id: string, name: string };

export type SearchIndexQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  where?: InputMaybe<CafeWhereInput>;
}>;


export type SearchIndexQuery = { __typename: 'Query', newCafes: { __typename: 'CafeConnection', totalCount: number, pageInfo: { __typename: 'NewPageInfo', hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'CafeEdge', node: { __typename: 'Cafe', id: string, databaseId: string, path?: string | null, access?: string | null, address1: string, address2?: string | null, branchName?: string | null, businessHours?: string | null, chargingMemo?: string | null, chargingPermission: ChargingPermission, city: string, createdAt: any, description: string, holiday?: string | null, latitude?: number | null, longitude?: number | null, memo?: string | null, mobileBatteryMemo?: string | null, mobileBatteryPermission: MobileBatteryPermission, name?: string | null, official?: boolean | null, outletsCount: number, phone?: string | null, postalcode: string, prefecture: string, recommendation?: string | null, reviewComment?: string | null, smoking: Smoking, takeAwayAvailable?: boolean | null, terraceSeatsAvailable: boolean, updatedAt: any, url?: string | null, wifi: WiFi, wifiMemo?: string | null, brand: { __typename: 'Brand', id: string, name: string }, cafeToCafeTags: Array<{ __typename: 'CafeToCafeTag', cafeTag?: { __typename: 'CafeTag', id: string, name: string, slug: string } | null }>, cafeToSponsors: Array<{ __typename: 'CafeToSponsor', sponsor?: { __typename: 'Sponsor', id: string, name: string } | null }>, cafeToUsages: Array<{ __typename: 'CafeToUsage', usage?: { __typename: 'Usage', id: string, name: string } | null }>, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }>, meal?: { __typename: 'Meal', id: string, alcohol: boolean, dessert: boolean, dinner: boolean, lunch: boolean, morning: boolean, snack: boolean } | null } }> } };

export type SearchListItem_StationFragment = { __typename: 'Station', id: string, databaseId: string, name: string, route?: string | null, address?: string | null, query: string, latitude: number, longitude: number };

export type TagsIndexQueryVariables = Exact<{
  cafeTagSlug: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type TagsIndexQuery = { __typename: 'Query', cafeTag: { __typename: 'CafeTag', id: string, databaseId: string, slug: string, name: string, archived: boolean }, cafes: { __typename: 'CafeConnection', totalCount: number, pageInfo: { __typename: 'NewPageInfo', hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'CafeEdge', node: { __typename: 'Cafe', id: string, databaseId: string, path?: string | null, access?: string | null, address1: string, address2?: string | null, branchName?: string | null, businessHours?: string | null, chargingMemo?: string | null, chargingPermission: ChargingPermission, city: string, createdAt: any, description: string, holiday?: string | null, latitude?: number | null, longitude?: number | null, memo?: string | null, mobileBatteryMemo?: string | null, mobileBatteryPermission: MobileBatteryPermission, name?: string | null, official?: boolean | null, outletsCount: number, phone?: string | null, postalcode: string, prefecture: string, recommendation?: string | null, reviewComment?: string | null, smoking: Smoking, takeAwayAvailable?: boolean | null, terraceSeatsAvailable: boolean, updatedAt: any, url?: string | null, wifi: WiFi, wifiMemo?: string | null, brand: { __typename: 'Brand', id: string, name: string }, cafeToCafeTags: Array<{ __typename: 'CafeToCafeTag', cafeTag?: { __typename: 'CafeTag', id: string, name: string, slug: string } | null }>, cafeToSponsors: Array<{ __typename: 'CafeToSponsor', sponsor?: { __typename: 'Sponsor', id: string, name: string } | null }>, cafeToUsages: Array<{ __typename: 'CafeToUsage', usage?: { __typename: 'Usage', id: string, name: string } | null }>, pictures: Array<{ __typename: 'Attachment', id: string, filename: string, url: string, kind: Kind, createdAt: any, updatedAt: any }>, meal?: { __typename: 'Meal', id: string, alcohol: boolean, dessert: boolean, dinner: boolean, lunch: boolean, morning: boolean, snack: boolean } | null } }> } };

export const ArticlePage_ArticleFragmentDoc = gql`
    fragment ArticlePage_article on Article {
  id
  contentId
  title
  content
  description
  image1
  image2
  image3
  image4
  createdAt
  updatedAt
}
    `;
export const CafePage_CafeTagFragmentDoc = gql`
    fragment CafePage_cafeTag on CafeTag {
  id
  name
  slug
}
    `;
export const CafePage_SponsorFragmentDoc = gql`
    fragment CafePage_sponsor on Sponsor {
  id
  name
}
    `;
export const CafePage_UsageFragmentDoc = gql`
    fragment CafePage_usage on Usage {
  id
  name
}
    `;
export const CafePage_AttachmentFragmentDoc = gql`
    fragment CafePage_attachment on Attachment {
  id
  filename
  url
  kind
  createdAt
  updatedAt
}
    `;
export const CafePage_MealFragmentDoc = gql`
    fragment CafePage_meal on Meal {
  id
  alcohol
  dessert
  dinner
  lunch
  morning
  snack
}
    `;
export const CafePage_CafeFragmentDoc = gql`
    fragment CafePage_cafe on Cafe {
  id
  databaseId
  path
  access
  address1
  address2
  branchName
  brand {
    id
    name
  }
  businessHours
  cafeToCafeTags {
    cafeTag {
      ...CafePage_cafeTag
    }
  }
  cafeToSponsors {
    sponsor {
      ...CafePage_sponsor
    }
  }
  cafeToUsages {
    usage {
      ...CafePage_usage
    }
  }
  chargingMemo
  chargingPermission
  city
  createdAt
  description
  holiday
  pictures {
    id
    ...CafePage_attachment
  }
  latitude
  longitude
  meal {
    id
    ...CafePage_meal
  }
  memo
  mobileBatteryMemo
  mobileBatteryPermission
  name
  official
  outletsCount
  phone
  postalcode
  prefecture
  recommendation
  reviewComment
  smoking
  takeAwayAvailable
  terraceSeatsAvailable
  updatedAt
  url
  wifi
  wifiMemo
}
    ${CafePage_CafeTagFragmentDoc}
${CafePage_SponsorFragmentDoc}
${CafePage_UsageFragmentDoc}
${CafePage_AttachmentFragmentDoc}
${CafePage_MealFragmentDoc}`;
export const HomeCafe_AttachmentFragmentDoc = gql`
    fragment HomeCafe_attachment on Attachment {
  id
  filename
  url
  kind
  createdAt
  updatedAt
}
    `;
export const HomeCafe_CafeFragmentDoc = gql`
    fragment HomeCafe_cafe on Cafe {
  id
  path
  branchName
  name
  description
  official
  access
  brand {
    id
    name
  }
  pictures {
    ...HomeCafe_attachment
  }
}
    ${HomeCafe_AttachmentFragmentDoc}`;
export const RelatedCafe_CafeFragmentDoc = gql`
    fragment RelatedCafe_cafe on Cafe {
  id
  databaseId
  path
  access
  address1
  address2
  branchName
  brand {
    id
    name
  }
  businessHours
  chargingMemo
  chargingPermission
  city
  createdAt
  description
  holiday
  pictures {
    ...CafePage_attachment
  }
  latitude
  longitude
  memo
  mobileBatteryMemo
  mobileBatteryPermission
  name
  official
  outletsCount
  phone
  postalcode
  prefecture
  recommendation
  reviewComment
  smoking
  takeAwayAvailable
  terraceSeatsAvailable
  updatedAt
  url
  wifi
  wifiMemo
}
    ${CafePage_AttachmentFragmentDoc}`;
export const SearchCafeUsagePicker_UsageFragmentDoc = gql`
    fragment SearchCafeUsagePicker_usage on Usage {
  id
  name
}
    `;
export const SearchListItem_StationFragmentDoc = gql`
    fragment SearchListItem_station on Station {
  id
  databaseId
  name
  route
  address
  query
  latitude
  longitude
}
    `;
export const ArticleDocument = gql`
    query Article($id: Int) {
  article(contentId: $id) {
    ...ArticlePage_article
  }
}
    ${ArticlePage_ArticleFragmentDoc}`;

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleQuery(baseOptions?: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
      }
export function useArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
        }
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleQueryResult = Apollo.QueryResult<ArticleQuery, ArticleQueryVariables>;
export const ArticlesIndexDocument = gql`
    query ArticlesIndex($first: Int, $after: ID, $order: Order) {
  articles(first: $first, after: $after, order: $order) {
    totalCount
    edges {
      node {
        id
        ...ArticlePage_article
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
  }
}
    ${ArticlePage_ArticleFragmentDoc}`;

/**
 * __useArticlesIndexQuery__
 *
 * To run a query within a React component, call `useArticlesIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesIndexQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useArticlesIndexQuery(baseOptions?: Apollo.QueryHookOptions<ArticlesIndexQuery, ArticlesIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlesIndexQuery, ArticlesIndexQueryVariables>(ArticlesIndexDocument, options);
      }
export function useArticlesIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesIndexQuery, ArticlesIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlesIndexQuery, ArticlesIndexQueryVariables>(ArticlesIndexDocument, options);
        }
export type ArticlesIndexQueryHookResult = ReturnType<typeof useArticlesIndexQuery>;
export type ArticlesIndexLazyQueryHookResult = ReturnType<typeof useArticlesIndexLazyQuery>;
export type ArticlesIndexQueryResult = Apollo.QueryResult<ArticlesIndexQuery, ArticlesIndexQueryVariables>;
export const CafeDocument = gql`
    query Cafe($path: String!) {
  cafe: cafeByPath(path: $path) {
    id
    ...CafePage_cafe
  }
}
    ${CafePage_CafeFragmentDoc}`;

/**
 * __useCafeQuery__
 *
 * To run a query within a React component, call `useCafeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCafeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCafeQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useCafeQuery(baseOptions: Apollo.QueryHookOptions<CafeQuery, CafeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CafeQuery, CafeQueryVariables>(CafeDocument, options);
      }
export function useCafeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CafeQuery, CafeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CafeQuery, CafeQueryVariables>(CafeDocument, options);
        }
export type CafeQueryHookResult = ReturnType<typeof useCafeQuery>;
export type CafeLazyQueryHookResult = ReturnType<typeof useCafeLazyQuery>;
export type CafeQueryResult = Apollo.QueryResult<CafeQuery, CafeQueryVariables>;
export const CafesIndexDocument = gql`
    query CafesIndex($after: String) {
  newCafes(
    first: 20
    after: $after
    orderBy: {createdAt: DESC}
    where: {archived: false}
  ) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        ...CafePage_cafe
      }
    }
  }
}
    ${CafePage_CafeFragmentDoc}`;

/**
 * __useCafesIndexQuery__
 *
 * To run a query within a React component, call `useCafesIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCafesIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCafesIndexQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCafesIndexQuery(baseOptions?: Apollo.QueryHookOptions<CafesIndexQuery, CafesIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CafesIndexQuery, CafesIndexQueryVariables>(CafesIndexDocument, options);
      }
export function useCafesIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CafesIndexQuery, CafesIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CafesIndexQuery, CafesIndexQueryVariables>(CafesIndexDocument, options);
        }
export type CafesIndexQueryHookResult = ReturnType<typeof useCafesIndexQuery>;
export type CafesIndexLazyQueryHookResult = ReturnType<typeof useCafesIndexLazyQuery>;
export type CafesIndexQueryResult = Apollo.QueryResult<CafesIndexQuery, CafesIndexQueryVariables>;
export const HeaderSearchDocument = gql`
    query HeaderSearch($query: String) {
  stations(first: 20, orderBy: {createdAt: DESC}, where: {query: $query}) {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        ...SearchListItem_station
      }
    }
  }
}
    ${SearchListItem_StationFragmentDoc}`;

/**
 * __useHeaderSearchQuery__
 *
 * To run a query within a React component, call `useHeaderSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useHeaderSearchQuery(baseOptions?: Apollo.QueryHookOptions<HeaderSearchQuery, HeaderSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderSearchQuery, HeaderSearchQueryVariables>(HeaderSearchDocument, options);
      }
export function useHeaderSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderSearchQuery, HeaderSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderSearchQuery, HeaderSearchQueryVariables>(HeaderSearchDocument, options);
        }
export type HeaderSearchQueryHookResult = ReturnType<typeof useHeaderSearchQuery>;
export type HeaderSearchLazyQueryHookResult = ReturnType<typeof useHeaderSearchLazyQuery>;
export type HeaderSearchQueryResult = Apollo.QueryResult<HeaderSearchQuery, HeaderSearchQueryVariables>;
export const HomeArticlesDocument = gql`
    query HomeArticles {
  articles(first: 3, order: CREATED) {
    edges {
      node {
        ...ArticlePage_article
      }
    }
  }
}
    ${ArticlePage_ArticleFragmentDoc}`;

/**
 * __useHomeArticlesQuery__
 *
 * To run a query within a React component, call `useHomeArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeArticlesQuery(baseOptions?: Apollo.QueryHookOptions<HomeArticlesQuery, HomeArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeArticlesQuery, HomeArticlesQueryVariables>(HomeArticlesDocument, options);
      }
export function useHomeArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeArticlesQuery, HomeArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeArticlesQuery, HomeArticlesQueryVariables>(HomeArticlesDocument, options);
        }
export type HomeArticlesQueryHookResult = ReturnType<typeof useHomeArticlesQuery>;
export type HomeArticlesLazyQueryHookResult = ReturnType<typeof useHomeArticlesLazyQuery>;
export type HomeArticlesQueryResult = Apollo.QueryResult<HomeArticlesQuery, HomeArticlesQueryVariables>;
export const HomeCafesDocument = gql`
    query HomeCafes {
  newCafes(first: 6, orderBy: {createdAt: DESC}, where: {archived: false}) {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        ...HomeCafe_cafe
      }
    }
  }
}
    ${HomeCafe_CafeFragmentDoc}`;

/**
 * __useHomeCafesQuery__
 *
 * To run a query within a React component, call `useHomeCafesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeCafesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeCafesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeCafesQuery(baseOptions?: Apollo.QueryHookOptions<HomeCafesQuery, HomeCafesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeCafesQuery, HomeCafesQueryVariables>(HomeCafesDocument, options);
      }
export function useHomeCafesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeCafesQuery, HomeCafesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeCafesQuery, HomeCafesQueryVariables>(HomeCafesDocument, options);
        }
export type HomeCafesQueryHookResult = ReturnType<typeof useHomeCafesQuery>;
export type HomeCafesLazyQueryHookResult = ReturnType<typeof useHomeCafesLazyQuery>;
export type HomeCafesQueryResult = Apollo.QueryResult<HomeCafesQuery, HomeCafesQueryVariables>;
export const HomeSearchDocument = gql`
    query HomeSearch($query: String, $region: StationRegionInput) {
  stations(orderBy: {createdAt: DESC}, where: {query: $query}, region: $region) {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        ...SearchListItem_station
      }
    }
  }
}
    ${SearchListItem_StationFragmentDoc}`;

/**
 * __useHomeSearchQuery__
 *
 * To run a query within a React component, call `useHomeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useHomeSearchQuery(baseOptions?: Apollo.QueryHookOptions<HomeSearchQuery, HomeSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeSearchQuery, HomeSearchQueryVariables>(HomeSearchDocument, options);
      }
export function useHomeSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeSearchQuery, HomeSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeSearchQuery, HomeSearchQueryVariables>(HomeSearchDocument, options);
        }
export type HomeSearchQueryHookResult = ReturnType<typeof useHomeSearchQuery>;
export type HomeSearchLazyQueryHookResult = ReturnType<typeof useHomeSearchLazyQuery>;
export type HomeSearchQueryResult = Apollo.QueryResult<HomeSearchQuery, HomeSearchQueryVariables>;
export const LatestArticlesDocument = gql`
    query LatestArticles {
  articles(first: 5, order: CREATED) {
    totalCount
    edges {
      node {
        ...ArticlePage_article
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
  }
}
    ${ArticlePage_ArticleFragmentDoc}`;

/**
 * __useLatestArticlesQuery__
 *
 * To run a query within a React component, call `useLatestArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestArticlesQuery(baseOptions?: Apollo.QueryHookOptions<LatestArticlesQuery, LatestArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestArticlesQuery, LatestArticlesQueryVariables>(LatestArticlesDocument, options);
      }
export function useLatestArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestArticlesQuery, LatestArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestArticlesQuery, LatestArticlesQueryVariables>(LatestArticlesDocument, options);
        }
export type LatestArticlesQueryHookResult = ReturnType<typeof useLatestArticlesQuery>;
export type LatestArticlesLazyQueryHookResult = ReturnType<typeof useLatestArticlesLazyQuery>;
export type LatestArticlesQueryResult = Apollo.QueryResult<LatestArticlesQuery, LatestArticlesQueryVariables>;
export const RelatedCafesDocument = gql`
    query RelatedCafes($latitude: Float!, $longitude: Float!) {
  newCafes(
    first: 3
    orderBy: {updatedAt: DESC}
    where: {archived: false}
    region: {latitude: $latitude, longitude: $longitude}
  ) {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        ...RelatedCafe_cafe
      }
    }
  }
}
    ${RelatedCafe_CafeFragmentDoc}`;

/**
 * __useRelatedCafesQuery__
 *
 * To run a query within a React component, call `useRelatedCafesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedCafesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedCafesQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useRelatedCafesQuery(baseOptions: Apollo.QueryHookOptions<RelatedCafesQuery, RelatedCafesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedCafesQuery, RelatedCafesQueryVariables>(RelatedCafesDocument, options);
      }
export function useRelatedCafesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedCafesQuery, RelatedCafesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedCafesQuery, RelatedCafesQueryVariables>(RelatedCafesDocument, options);
        }
export type RelatedCafesQueryHookResult = ReturnType<typeof useRelatedCafesQuery>;
export type RelatedCafesLazyQueryHookResult = ReturnType<typeof useRelatedCafesLazyQuery>;
export type RelatedCafesQueryResult = Apollo.QueryResult<RelatedCafesQuery, RelatedCafesQueryVariables>;
export const SearchCafeUsagePickerDocument = gql`
    query SearchCafeUsagePicker {
  usages(first: 100, orderBy: {createdAt: DESC}) {
    edges {
      node {
        ...SearchCafeUsagePicker_usage
      }
    }
  }
}
    ${SearchCafeUsagePicker_UsageFragmentDoc}`;

/**
 * __useSearchCafeUsagePickerQuery__
 *
 * To run a query within a React component, call `useSearchCafeUsagePickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCafeUsagePickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCafeUsagePickerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchCafeUsagePickerQuery(baseOptions?: Apollo.QueryHookOptions<SearchCafeUsagePickerQuery, SearchCafeUsagePickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCafeUsagePickerQuery, SearchCafeUsagePickerQueryVariables>(SearchCafeUsagePickerDocument, options);
      }
export function useSearchCafeUsagePickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCafeUsagePickerQuery, SearchCafeUsagePickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCafeUsagePickerQuery, SearchCafeUsagePickerQueryVariables>(SearchCafeUsagePickerDocument, options);
        }
export type SearchCafeUsagePickerQueryHookResult = ReturnType<typeof useSearchCafeUsagePickerQuery>;
export type SearchCafeUsagePickerLazyQueryHookResult = ReturnType<typeof useSearchCafeUsagePickerLazyQuery>;
export type SearchCafeUsagePickerQueryResult = Apollo.QueryResult<SearchCafeUsagePickerQuery, SearchCafeUsagePickerQueryVariables>;
export const SearchIndexDocument = gql`
    query SearchIndex($after: String, $latitude: Float!, $longitude: Float!, $where: CafeWhereInput) {
  newCafes(
    first: 20
    after: $after
    where: $where
    orderBy: {updatedAt: DESC}
    region: {latitude: $latitude, longitude: $longitude}
  ) {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        ...CafePage_cafe
      }
    }
  }
}
    ${CafePage_CafeFragmentDoc}`;

/**
 * __useSearchIndexQuery__
 *
 * To run a query within a React component, call `useSearchIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIndexQuery({
 *   variables: {
 *      after: // value for 'after'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchIndexQuery(baseOptions: Apollo.QueryHookOptions<SearchIndexQuery, SearchIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchIndexQuery, SearchIndexQueryVariables>(SearchIndexDocument, options);
      }
export function useSearchIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchIndexQuery, SearchIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchIndexQuery, SearchIndexQueryVariables>(SearchIndexDocument, options);
        }
export type SearchIndexQueryHookResult = ReturnType<typeof useSearchIndexQuery>;
export type SearchIndexLazyQueryHookResult = ReturnType<typeof useSearchIndexLazyQuery>;
export type SearchIndexQueryResult = Apollo.QueryResult<SearchIndexQuery, SearchIndexQueryVariables>;
export const TagsIndexQueryDocument = gql`
    query TagsIndexQuery($cafeTagSlug: String!, $after: String) {
  cafeTag: cafeTagBySlug(slug: $cafeTagSlug) {
    id
    databaseId
    slug
    name
    archived
  }
  cafes: cafesByCafeTag(
    first: 20
    after: $after
    orderBy: {updatedAt: DESC}
    where: {cafeTagSlug: $cafeTagSlug, archived: false}
  ) {
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        ...CafePage_cafe
      }
    }
  }
}
    ${CafePage_CafeFragmentDoc}`;

/**
 * __useTagsIndexQuery__
 *
 * To run a query within a React component, call `useTagsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsIndexQuery({
 *   variables: {
 *      cafeTagSlug: // value for 'cafeTagSlug'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTagsIndexQuery(baseOptions: Apollo.QueryHookOptions<TagsIndexQuery, TagsIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsIndexQuery, TagsIndexQueryVariables>(TagsIndexQueryDocument, options);
      }
export function useTagsIndexQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsIndexQuery, TagsIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsIndexQuery, TagsIndexQueryVariables>(TagsIndexQueryDocument, options);
        }
export type TagsIndexQueryHookResult = ReturnType<typeof useTagsIndexQuery>;
export type TagsIndexQueryLazyQueryHookResult = ReturnType<typeof useTagsIndexQueryLazyQuery>;
export type TagsIndexQueryQueryResult = Apollo.QueryResult<TagsIndexQuery, TagsIndexQueryVariables>;